import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Toggle} from '../../../../../libs/shared/ui/src/components/booleanInputs/toggle';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {ChannelEmailModel} from '../../../../models/api/channelModel';
import {
  renderSummaryValueForBoolean,
  SettingsAccordionFieldLine,
} from '../../../common/settingsAccordionFieldLine';
import {SettingsFieldLine} from '../../../common/settingsFieldLine';
import {StyledSettingsFormTextBox} from '../../../common/settingsWrapper';
import {SettingsCommonChannelFieldProps} from '../settingsCommonChannelFields';

/*
 * Props.
 */

interface SettingsAutoBccFieldProps extends SettingsCommonChannelFieldProps<ChannelEmailModel> {}

/*
 * Component.
 */

export const SettingsAutoBccField: FC<SettingsAutoBccFieldProps> = (props) => (
  <SettingsAccordionFieldLine
    title={<Trans id="settingschannel-autobcc-title">Auto BCC</Trans>}
    subtitle={
      <Trans id="settingschannel-autobcc-subtitle">
        These addresses will be added as Bcc when you compose or reply.
      </Trans>
    }
    summaryValue={renderSummaryValueForBoolean(props.edited.preferences.autoBcc.isEnabled)}
  >
    <SettingsFieldLine
      hasNoBorder
      title={<Trans id="settingschannel-autobcc-enable">Add Bcc to all outgoing emails</Trans>}
      content={
        <Toggle
          isChecked={props.edited.preferences.autoBcc.isEnabled}
          onChange={(bool) =>
            props.onPreferencesChange({autoBcc: {...props.edited.preferences.autoBcc, isEnabled: bool}})
          }
        />
      }
    />
    <StyledSettingsFormTextBox
      $width={450}
      label={<Trans id="settingschannel-bcc">BCC</Trans>}
      size={VisualSizesEnum.MEDIUM}
      value={props.edited.preferences.autoBcc.handles.join(';')}
      isDisabled={!props.edited.preferences.autoBcc.isEnabled}
      message={
        <Trans id="settingschannel-bcc-message">
          You can define multiples addresses separated by semicolons
        </Trans>
      }
      onChange={(newValue) => {
        const handles = newValue.split(';').map((i) => i.trim());
        props.onPreferencesChange({autoBcc: {...props.edited.preferences.autoBcc, handles}});
      }}
    />
  </SettingsAccordionFieldLine>
);
